import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { FaTools, FaClock, FaEnvelope, FaSignInAlt } from 'react-icons/fa';
import './MaintenancePage.css';

const MaintenancePage = ({ onLoginClick }) => {
    const [message, setMessage] = useState('Site is under maintenance. We will be back shortly.');
    const [timeLeft, setTimeLeft] = useState('');
    
    useEffect(() => {
        // Fetch maintenance message
        const fetchMaintenanceMessage = async () => {
            try {
                const response = await axios.get('https://hsn.urugowoc.org.rw/backend/api/maintenance-status');
                if (response.data.message) {
                    setMessage(response.data.message);
                }
            } catch (error) {
                console.error('Error fetching maintenance message:', error);
            }
        };
        
        fetchMaintenanceMessage();
        
        // Simple countdown timer (example: 2 hours from now)
        const maintenanceEnd = new Date();
        maintenanceEnd.setHours(maintenanceEnd.getHours() + 2);
        
        const timer = setInterval(() => {
            const now = new Date();
            const diff = maintenanceEnd - now;
            
            if (diff <= 0) {
                clearInterval(timer);
                setTimeLeft('');
                return;
            }
            
            const hours = Math.floor(diff / (1000 * 60 * 60));
            const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
            const seconds = Math.floor((diff % (1000 * 60)) / 1000);
            
            setTimeLeft(`${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`);
        }, 1000);
        
        return () => clearInterval(timer);
    }, []);
    
    return (
        <div className="maintenance-container">
            <div className="maintenance-content">
                <div className="maintenance-icon">
                    <FaTools />
                </div>
                <h1>Under Maintenance</h1>
                <p className="maintenance-message">{message}</p>
                
                {timeLeft && (
                    <div className="maintenance-timer">
                        <FaClock />
                        <span>Estimated time: {timeLeft}</span>
                    </div>
                )}
                
                <div className="maintenance-info">
                    <p>We're currently performing scheduled maintenance to improve your experience.</p>
                    <p>Administrators can login to access the dashboard.</p>
                </div>
                
                <div className="maintenance-actions">
                    <button 
                        className="admin-login-btn"
                        onClick={onLoginClick}
                    >
                        <FaSignInAlt /> Manager Login
                    </button>
                    
                    <a href="mailto:info@urugowoc.org" className="contact-btn">
                        <FaEnvelope /> Contact Support
                    </a>
                </div>
                
                <div className="maintenance-footer">
                    <button 
                        className="refresh-btn"
                        onClick={() => window.location.reload()}
                    >
                        Refresh Page
                    </button>
                </div>
            </div>
        </div>
    );
};

export default MaintenancePage;